import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a63810910388a6c320b1edfa768c98542b from "./generated-34863ad0-0d15-42d5-bdd9-0df4df84cecf.json";

import a0cec7ca3b3df82956c2f30d556e19301b from "./generated-35cc736f-7aed-434a-a5f1-9a6643dac419.json";

import ac3368ca9cea17a74482f60a030e7308fb from "./generated-eca7e971-e248-4c88-b144-27d2fbcad237.json";

import a461a79e682f3c7f0875927479a736e46b from "./generated-c642409f-6bdf-4bbe-b840-5f842d983b87.json";

import aa984c57bdfd38caf144eb61111f702ceb from "./generated-379808f1-523e-4b16-a6c1-b4a3cd5e89bd.json";

import ad9039d17e70381c53a3a4899e2e36c26b from "./generated-d5da40fc-6cdb-4d55-bce4-f9c0446d777b.json";

import ab1b892c01539c3b3d6a0eb3e08300d54b from "./generated-4031bc29-2801-4dc5-bc9b-15cbfe7807c3.json";

import a830c9b4b8ed7044a7393f23c786e7cf6b from "./generated-1edd1de0-bcf0-4963-865a-4123eef9f3d0.json";

import a84703d2168f873813f7a63cfdd10987db from "./generated-524d23d4-5032-422c-b5b6-9bde95cb6a68.json";

import a71ffaa0367b87016590adbabe42f8253b from "./generated-6c471a50-4e68-498c-a40e-ff71c2fdfb1d.json";

import a56d50cafc0b4343ee48ef2e175b9a0dcb from "./generated-933747e2-369d-4167-8f18-65a706a7cd93.json";

import a509ff8e16adb2980792bb250b48b71fcb from "./generated-1974d003-13fe-4dd7-93e0-ac4267930cd7.json";

import a55e67dad65f3c085ae2b563d4cd6a35ab from "./generated-913ae3a7-fc90-4d97-a79d-e89371194709.json";

import ae59b28bf3c6d1c3e5a10ae9ff8a4f1c1b from "./generated-256fc4dc-346e-48e3-806a-319b12472387.json";

import a46504910d747ecb1fbfbec2b1d890bcab from "./generated-247b5b74-b239-455f-a174-aa0c3da95554.json";

import a8b8d83bdc48420f7c275caf056bf1097b from "./generated-ca3be4ca-6fe6-4f4c-8ce1-43641d6d7163.json";

import a889ac7bd6eb332ebdc8433ebc0d3285bb from "./generated-7dcb7114-efb8-400d-b634-2ebdc469c875.json";

import a04d66d71eaaecb2b70287eced17b3facb from "./generated-3b0af2b5-64f0-4c86-9dc7-d1021cc3e2b9.json";

import ac6f0486c336454c0b5857ab6b3e6a305b from "./generated-c6e61e82-7b36-407c-bd3b-e22161f8761f.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a63810910388a6c320b1edfa768c98542b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a0cec7ca3b3df82956c2f30d556e19301b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ac3368ca9cea17a74482f60a030e7308fb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a461a79e682f3c7f0875927479a736e46b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aa984c57bdfd38caf144eb61111f702ceb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ad9039d17e70381c53a3a4899e2e36c26b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ab1b892c01539c3b3d6a0eb3e08300d54b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a830c9b4b8ed7044a7393f23c786e7cf6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a84703d2168f873813f7a63cfdd10987db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a71ffaa0367b87016590adbabe42f8253b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a56d50cafc0b4343ee48ef2e175b9a0dcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a509ff8e16adb2980792bb250b48b71fcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a55e67dad65f3c085ae2b563d4cd6a35ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ae59b28bf3c6d1c3e5a10ae9ff8a4f1c1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a46504910d747ecb1fbfbec2b1d890bcab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a8b8d83bdc48420f7c275caf056bf1097b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a889ac7bd6eb332ebdc8433ebc0d3285bb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a04d66d71eaaecb2b70287eced17b3facb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ac6f0486c336454c0b5857ab6b3e6a305b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a889ac7bd6eb332ebdc8433ebc0d3285bb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */